import React from "react";
import { observer } from "mobx-react";
import InvoiceViewPage from "~/modules/BillingCentral/app/InvoiceViewPage";
import "../styles/SidePage.less";

const ClientPanelInvoiceViewPage = observer(props => <InvoiceViewPage {...props} />);

export default ClientPanelInvoiceViewPage;
